<template>
  <a-card class="card-box" :bordered="false" :style="{ marginBottom: '24px' }">
    <div style="display: flex; justify-content: space-between; align-items: center">
      <div style="font-size: 16px; font-weight: bold">
        {{ name + '【情绪趋势分析】' }}
      </div>
      <div style="display: flex">
        <a-button type="primary" class="custom-btn" @click="addCompareData" v-if="!hiddenCompare">
          添加对比
        </a-button>
        <a-button type="primary" class="custom-btn" @click="showLineDetail">查看详情</a-button>
        <a-button
          v-has="'studentPic:show'"
          type="primary"
          class="custom-btn"
          @click="showImgDetail"
        >
          查看照片
        </a-button>
        <a-button type="primary" class="custom-btn" @click="addEventClick">添加事件</a-button>
        <a-icon
          class="delete-icon"
          type="close"
          :style="{ fontSize: '18px', color: '#ccc' }"
          @click="deleteRecord"
        />
      </div>
    </div>
    <div class="salesCard">
      <!-- <smooth-line-chart-multid
        :height="220"
        :fields="moodField"
        :dataSource="dataSource"
        :yAxisMultiple="1.15"
        :isShowNoDataIcon="true"
        @lineChartClick="lineChartClick"
      /> -->
      <LineChart
        height="220px"
        :fields="moodField"
        :dataSource="dataSource"
        :yAxisMultiple="1.15"
      />
    </div>
    <ViewKeyPointModal ref="viewKeyPointModal" />
    <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
  </a-card>
</template>

<script>
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import ViewKeyPointModal from './ViewKeyPointModal'
import Radar from '@/components/chart/Radar'
import { mapGetters } from 'vuex'
import AddEventModal from './AddEventModal'
import LineChart from '@/components/echartZyz/components/LineChart'

export default {
  name: 'StuLineMoodCard',
  components: {
    SmoothLineChartMultid,
    ViewKeyPointModal,
    Radar,
    AddEventModal,
    LineChart,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    moodField: {
      type: Array,
      default: () => [],
    },
    studentInfo: {
      type: Object,
      default: () => ({}),
    },
    hiddenCompare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeType: 'last7days',
      timeTypeOptions: [
        {
          label: '今天',
          value: 'today',
        },
        {
          label: '近七天',
          value: 'last7days',
        },
        {
          label: '近20天',
          value: 'last20days',
        },
        {
          label: '近40天',
          value: 'last40days',
        },
        {
          label: '近三个月',
          value: 'last3months',
        },
        {
          label: '近半年',
          value: 'last6months',
        },
      ],
      radarData: [
        {
          fields: ['学生模型'],
          data: [
            { item: '认知能力', 学生模型: 80 },
            { item: '理工类专业匹配指数', 学生模型: 30 },
            { item: '人文类专业匹配指数', 学生模型: 60 },
            { item: '技术类专业匹配指数', 学生模型: 30 },
            { item: '非技术类专业匹配指数', 学生模型: 40 },
            { item: '亲子关系', 学生模型: 70 },
            { item: '心理健康风险', 学生模型: 10 },
            { item: '负面心态风险', 学生模型: 20 },
          ],
        },
        {
          fields: ['个人成绩'],
          data: [
            { item: '语文', 个人成绩: 80 },
            { item: '数学', 个人成绩: 100 },
            { item: '英语', 个人成绩: 100 },
            { item: '物理', 个人成绩: 80 },
            { item: '化学', 个人成绩: 100 },
            { item: '历史', 个人成绩: 90 },
            { item: '政治', 个人成绩: 98 },
            { item: '地理', 个人成绩: 99 },
            { item: '体育', 个人成绩: 92 },
            { item: '美术', 个人成绩: 93 },
          ],
        },
      ],
      eventModalVisible: false,
    }
  },
  methods: {
    ...mapGetters(['userInfo']),
    showImgDetail() {
      this.$emit('showImgDetail')
    },
    lineChartClick() {
      this.$emit('lineChartClick')
    },
    showLineDetail() {
      // console.log('学生信息====', this.studentInfo)
      this.$refs.viewKeyPointModal.show(this.studentInfo, 2)
    },
    // 添加对比
    addCompareData() {
      this.$emit('addStuCompareData', this.studentInfo)
    },
    // 添加事件
    addEventClick() {
      // console.log('折线图数据：', this.dataSource)
      this.$refs.addEventModal.show(this.dataSource, this.moodField)
    },
    // 刷新标注
    refreshMarked(record) {
      this.$emit('refreshMarked', record)
      const porintIndex = this.dataSource.findIndex(
        (item) =>
          item[record.filed + 'id'] == record.id &&
          item[record.filed + 'incident'] == record.incident &&
          item.type == record.type
      )
      if (porintIndex != -1) {
        const incident = record.filed + 'incident'
        this.$set(this.dataSource[porintIndex], incident, 1)
        this.dataSource = [...this.dataSource]
        // console.log('刷新标注后的数据：', this.dataSource)
      }
    },
    deleteRecord() {
      this.$emit('deleteRecord', this.studentInfo)
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  margin-right: 12px;
}
.card-box {
  border: 1px solid #ccc;
  border-radius: 10px;
  margin: 10px;
  /deep/ .ant-card-body {
    // padding: 20px 10px;
    position: relative;
    .delete-icon {
      position: absolute;
      top: 6px;
      right: 6px;
      cursor: pointer;
    }
  }
}
.line-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom-btn {
  margin-right: 8px;
  background-color: #ffffff;
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
  box-shadow: none;
}
</style>
